import { useState, useEffect, useRef } from 'react';
import { Text } from '@react-three/drei';
import { useCursor } from '@react-three/drei';
import * as THREE from 'three';
import { useFrame } from '@react-three/fiber';

export function Frame({ id, name, width = 1, height = 1.8, texture, ...props }) {
  const [hovered, hover] = useState(false);
  const meshRef = useRef();
  const pointerDownInterval = 300;
  const pointerDownTime = useRef(0);

  useCursor(hovered);

  const handlePointerDown = (e) => {
    e.stopPropagation();
    pointerDownTime.current = Date.now();
  };

  const handlePointerUp = (e) => {
    e.stopPropagation();
    const pointerUpTime = Date.now();
    const pressDuration = pointerUpTime - pointerDownTime.current;

    if (pressDuration < pointerDownInterval) {
      props.onEnter?.();
    }
  };

  return (
    <group {...props}>
      <ambientLight intensity={0.5} />
      <Text
        color="white"
        font="/wp-content/plugins/virtualspace-demo/build/Futura_XBlack.ttf"
        anchorY="top"
        fontSize={0.3}
        anchorX="center"
        lineHeight={0.8}
        position={[0, 0.25, 0.05]}
        material-toneMapped={false}
      >
        {name}
      </Text>

      {hovered && (
        <Text
          color="#a1a1a1"
          font="/wp-content/plugins/virtualspace-demo/build/Futura_medium.ttf"
          fontSize={0.08}
          textAlign={'center'}
          lineHeight={1.2}
          anchorX="center"
          position={[0, -1, 0.01]}
          material-toneMapped={false}
        >
          Click to enter
        </Text>
      )}

      <mesh
        ref={meshRef}
        name={id}
        onPointerDown={handlePointerDown}
        onPointerUp={handlePointerUp}
        onPointerOver={() => hover(true)}
        onPointerOut={() => hover(false)}
      >
        <roundedPlaneGeometry args={[width, height, 0.1]} />
        <meshStandardMaterial
          color={hovered ? '#dbdbdb' : '#fff'}
          roughness={1}
          metalness={0}
          side={THREE.DoubleSide}
          map={texture}
        />
      </mesh>
    </group>
  );
}